import { createAsyncThunk } from '@reduxjs/toolkit';
import { Attendee } from 'src/types/types';
import { fetchAttendeeActivitiesApi } from 'src/redesign/features/AttendeesSidebar/views/ActivitiesSidebarView/store/api';

export const getAttendeeActivitiesData = createAsyncThunk(
  'attendee-activities/get-attendee-activities-data',
  async (attendeeId: Attendee['id'], { getState }) =>
    await fetchAttendeeActivitiesApi(getState(), attendeeId)
);
